// extracted by mini-css-extract-plugin
export default {"productCarousel":"Z1-z"};